import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { ProfileContainer } from "./style";
import * as types from "../../../actions/actionTypes";
import { Menu } from "../header/components/menu";
import CurrentProject from "../header/components/currentProject";
import ProjectList from "../header/components/projectList";

class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      profileMenu: false
    };
    this.toggleProfileMenu = this.toggleProfileMenu.bind(this);
  }
  toggleProfileMenu() {
    this.setState({
      profileMenu: !this.state.profileMenu
    });
  }
  render() {
    const { profileMenu } = this.state;
    const { data } = this.props;
    return (
      <React.Fragment>
        <ProfileContainer>
          <div onClick={this.toggleProfileMenu}>
            <div
              className="profile-project-name"
              title={data.length !== 0 && data.project.name}
            >
              {data.length !== 0 && data.project.name}
            </div>
            <div className="profile-user-name">
              {data.length !== 0 && data.user.fullName}
            </div>
          </div>
          <i
            onClick={this.toggleProfileMenu}
            title="حساب‌کاربری"
            className={
              (profileMenu ? "pressed " : "") +
              "profile-icon icon mapsa-down-arrow"
            }
          />
          {profileMenu && (
            <Menu showMenu={profileMenu} close={this.toggleProfileMenu}>
              <CurrentProject
                  wallet={data.user.wallet}
                  userInfoData={data.length !== 0 && data.user.fullName}
                  currentProject={
                    data.length !== 0 && data.project.name
                  }
              />
              <ProjectList
                close={this.toggleProfileMenu}
              />
            </Menu>
          )}
        </ProfileContainer>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    data: state.Init.data.data || []
  };
};

const mapDispatchToProps = dispatch => {
  return {
    requestInit: () => {
      dispatch({ type: types.INIT_REQUEST });
    }
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Profile)
);